/* eslint-disable import/no-extraneous-dependencies */
import { useState, useContext } from 'react';
import AppStateContext from '../app/context/appStateContext';
import APIHelper from "./useAPIHelper";
import PostNewService from "../functions/ServicePostNewServiceFunction";

const useLogJobForm = (callback: any) => {
  const { contractList,selectedCustomerId, contractCriticalCode, token, serviceCentreCode } = useContext(AppStateContext);
  const postNewService = APIHelper();

  const [inputs, setInputs] = useState({
    contractNo: Object.keys(contractList[selectedCustomerId])[0],
    issueTitle: '',
    location: '',
    customerReference: '',
    priorityCode: Object.keys(contractCriticalCode).length,
    asset: '',
    name: '',
    phone: '',
    department: '',
    itemcode: '',
    serviceCentreCode: serviceCentreCode,
    selectedCustomerId: selectedCustomerId
  });

  const resetInputs = () => {
    setInputs({
      contractNo: contractList[selectedCustomerId][0],
      issueTitle: '',
      location: '',
      customerReference: '',
      priorityCode: 4,
      asset: '',
      name: '',
      phone: '',
      department: '',
      itemcode: '',
      serviceCentreCode: serviceCentreCode,
      selectedCustomerId: selectedCustomerId,
    })
  };

  const checkForEmpty = () => {
    return inputs.issueTitle == '' || inputs.customerReference == '' || inputs.contractNo == '' || inputs.location == '';
  };

  const handleSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
      if(checkForEmpty()) {
        callback('empty');
      } else {
        postNewService.run(PostNewService, callback, [inputs, token])
      }
    }
  };

  const handleInputChange = (event: any) => {
    event.persist();
    setInputs(inputChange => ({ ...inputChange, [event.target.name]: event.target.value }));
  };

  const handleMultipleInput = (object: any, type: string) => {
    if(type == 'asset')
      setInputs(inputChange => ({...inputChange, asset: object.SerialNo, itemcode: object.ItemCode}))
    if(type == 'user info')
      setInputs(inputChange => ({...inputChange, name: object.ContactName, phone: object.ContactPhone}))
  };

  return {
    handleSubmit,
    handleInputChange,
    handleMultipleInput,
    resetInputs,
    inputs,
  };
};

export default useLogJobForm;
